import React, { useEffect, useState } from 'react';
import { Grid, TextField, Typography, Paper, Chip } from '@material-ui/core';
import { DateTimePicker,MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import EventTwoToneIcon from '@material-ui/icons/Event';

import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { presentFormatedData } from '../../../../functionalComponents/dataFormatFunctions';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  fieldLabel: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    },
    textSty: {
        '& .MuiOutlinedInput-input':{
            padding:'5px'
        }
    },
    table: {
        // minWidth: 400, // Adjust as needed
        border: "1px solid #ccc", // Border for table
      },
      tableHead: {
        backgroundColor: "#f5f5f5", // Light grey background for header
  },
  chipContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5),
    border: '1px solid #c4c4c4',
    borderRadius: theme.shape.borderRadius,
    padding:'10px',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

const ViewProcedureSection = (props) => {
    const classes = useStyles();
    const { data, sample } = props;

  const calculateDelay = () => {
    const start = data?.actualEndTime  ? data?.scheduledEndTime : data?.actualStartTime ? data?.scheduledStartTime : data?.scheduledEndTime;
    const end = data?.actualEndTime ? data?.actualEndTime : data?.actualStartTime;

    if (end) {
      const duration = moment.duration(moment(end).diff(moment(start)));
      
      // Extract hours and minutes
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
  
      return `${hours} hrs ${minutes} min`; // Format in hours and minutes
    }
  
    return 'N/A';
  };
    
   
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <div className={classes.root}>
              {/* Procedure Numbers Section */}
              <Grid container item xs={12} style={{ marginBottom:'1rem'}}>
          <Typography className={classes.fieldLabel}>Procedure Numbers</Typography>
          <Grid container >
                      <Grid item xs={12}>
                          <Typography>{sample ? presentFormatedData(data?.procedureNumber) : `${presentFormatedData(data?.procedureNumberStart)} to ${presentFormatedData(data?.procedureNumberEnd)}`}</Typography>

            </Grid>
                  
          </Grid>
          
        </Grid>
        {!sample && 
          <Grid container item xs={12} style={{ marginBottom:'1rem'}}>
          <Typography className={classes.fieldLabel}>Key Equipment ID</Typography>
          <Grid container >
                      <Grid item xs={12}>
                      <Paper className={classes.chipContainer}>
          {data?.keyEquipmentIDs ? data?.keyEquipmentIDs.split(',').map(id => id.trim()).map((chip, index) => (
            <Chip
              key={index}
              label={chip}
              className={classes.chip}
            />
          )):<Typography>-NA-</Typography>}
        </Paper>

            </Grid>
                  
          </Grid>
          
        </Grid>
        }
        
        {!sample && <>
          {/* Delay Section */}
          <Grid container item xs={12} style={{flexDirection:'column', marginTop:'1rem', marginBottom:'1rem'}} >
          <Typography className={classes.fieldLabel}>Delay</Typography>
          <Typography>{calculateDelay()}</Typography>
          </Grid>

              {/* Scheduled Start and End Time Section */}
              <Grid container item xs={12} style={{ marginTop:'1rem', marginBottom:'1rem'}}>
              <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell>Scheduled Start Time</TableCell>
          <TableCell>Actual Start Time</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell  style={{whiteSpace:'nowrap'}}>
            {data?.scheduledStartTime ? moment(data.scheduledStartTime).format("DD-MMM-YYYY HH:mm:ss"):'-NA-'}
                                  </TableCell>
                                  
                                  <TableCell>
                                  {data?.actualStartTime ? moment(data.actualStartTime).format("DD-MMM-YYYY HH:mm:ss"):'-NA-'}
          </TableCell>
        </TableRow>
      </TableBody>
                  </Table>
                  </Grid>
                  <Grid container item xs={12} style={{ marginTop:'1rem', marginBottom:'1rem'}}>
                  <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell>Scheduled End Time</TableCell>
          <TableCell>Actual End Time</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{whiteSpace:'nowrap'}}>
            {data?.scheduledEndTime ? moment(data.scheduledEndTime).format("DD-MMM-YYYY HH:mm:ss"):'-NA-'}
          </TableCell>
                                  <TableCell>
                                  {data?.actualEndTime ? moment(data.actualEndTime).format("DD-MMM-YYYY HH:mm:ss"):'-NA-'}
          </TableCell>
        </TableRow>
      </TableBody>
                  </Table>
                  </Grid>
        </>}
              
      </div>
    </MuiPickersUtilsProvider>
  );
}

export default ViewProcedureSection